import React, { useState } from 'react';
import LocationDropdown from '../../Dropdown/LocationName';

const AreaModal = ({ formData, onChange, onSave, editId }) => {
  const riskCategories = ['High', 'Low'];
  const [touchedFields, setTouchedFields] = useState({
    location_id: false,
    area_name: false,
    risk_category: false
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    // Mark all fields as touched when submitting
    setTouchedFields({
      location_id: true,
      area_name: true,
      risk_category: true
    });

    // Check if all required fields are filled
    if (formData.location_id && formData.area_name?.trim() && formData.risk_category) {
      onSave();
    }
  };

  const handleBlur = (fieldName) => {
    if (!touchedFields[fieldName]) {
      setTouchedFields(prev => ({
        ...prev,
        [fieldName]: true
      }));
    }
  };

  const shouldShowValidation = (fieldName) => {
    return touchedFields[fieldName] && !formData[fieldName]?.toString().trim();
  };

  return (
    <div
      className="modal fade"
      id="bs-area-modal"
      tabIndex="-1"
      aria-labelledby="bs-area-modal-label"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-scrollable modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{editId ? 'Edit Area' : 'Add Area'}</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              id="close-area-modal"
              aria-label="Close"
            ></button>
          </div>

          <div className="modal-body">
            <form onSubmit={handleSubmit}>
              {/* Location Dropdown */}
              <div className="mb-3">
                <label className="form-label fw-semibold">Location</label>
                <LocationDropdown
                  value={formData.location_id}
                  onChange={onChange}
                  onBlur={() => handleBlur('location_id')}
                  hasError={shouldShowValidation('location_id')}
                />
                {shouldShowValidation('location_id') && (
                  <div className="invalid-feedback d-block">Location is required</div>
                )}
              </div>

              {/* Area Name */}
              <div className="mb-3">
                <label className="form-label fw-semibold">Area Name</label>
                <input
                  type="text"
                  name="area_name"
                  className={`form-control ${shouldShowValidation('area_name') ? 'is-invalid' : ''}`}
                  placeholder="Enter area name"
                  value={formData.area_name || ''}
                  onChange={onChange}
                  onBlur={() => handleBlur('area_name')}
                />
                {shouldShowValidation('area_name') && (
                  <div className="invalid-feedback">Area name is required</div>
                )}
              </div>

              {/* Risk Category */}
              <div className="mb-3">
                <label className="form-label fw-semibold">Risk Category</label>
                <select
                  name="risk_category"
                  value={formData.risk_category || ''}
                  onChange={onChange}
                  className={`form-select ${shouldShowValidation('risk_category') ? 'is-invalid' : ''}`}
                  onBlur={() => handleBlur('risk_category')}
                >
                  <option value="">Select Category</option>
                  {riskCategories.map((cat, idx) => (
                    <option key={idx} value={cat}>
                      {cat}
                    </option>
                  ))}
                </select>
                {shouldShowValidation('risk_category') && (
                  <div className="invalid-feedback">Risk category is required</div>
                )}
              </div>
            </form>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-outline-danger"
              data-bs-dismiss="modal"
              id="close-area-modal"
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleSubmit}
            >
              {editId ? 'Update Area' : 'Save Area'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AreaModal;